/** Values stored in `site_visits.billingDecision` (MySQL enum). */
export const SVR_BILLING_DECISION_VALUES = [
  "bill",
  "no_charge_warranty_goodwill",
  "no_charge_contract",
  "not_billable_new_job_within_1_year",
] as const;

export type SvrBillingDecision = (typeof SVR_BILLING_DECISION_VALUES)[number];

/** Short labels for SVR views, emails, and analytics exports. */
export function formatSvrBillingDecisionLabel(d: string | null | undefined): string {
  switch (d) {
    case "bill":
      return "Billable";
    case "no_charge_warranty_goodwill":
      return "Goodwill";
    case "no_charge_contract":
      return "Within Warranty";
    case "not_billable_new_job_within_1_year":
      return "New Job (Within 1 Year)";
    default:
      return d ? String(d) : "—";
  }
}
